import React from 'react'
import { useUsersController } from './UsersController'
import { UsersView } from './UsersView'

const UsersPage: React.FC = () => {
    const controller = useUsersController()
    return <UsersView {...controller} />
}

export default UsersPage
